import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FormControl, Tab, Grid, Table, CommonErrors } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { Page, Group, Layout, Button, ExcelUpload } from "@/comn/components";
import { lpcoEnvs, lpcoUtils } from "@/tz/go/egaz/osci/lpco/comn";
import {
    useForm,
    useFetch,
    useGrid,
    useResource,
    usePopup,
    useStore,
    useToast,
    useAuth,
    useModal,
    useTab,
    usePage,
} from "@/comn/hooks";
import {
    BASE,
    URLS,
    APIS,
    SF_SRCH_HS_CTGR,
    SG_HS_CTGR_LIST,
} from "@/tz/go/egaz/osci/lpco/hscd/ctgr/service/OsciHscdCtgrService";

/**
 * HS Code Category List
 * !== HS 코드 카테고리 목록 ==!
 */
export const OSCI0204006Q = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0004"],
    });
    const pgeTitle = "Registering Control HS Code"; // Page Title !== 페이지 타이틀 ==!
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!

    const [hsCdList, setHsCdList] = useState(comnUtils.getGridData([]));

    /*
     * Code Resource
     * !== 사용할 Code 정의 ==!
     */
    useResource({
        defaultSchema: [{ area: "hsCd" }, { area: "comnCd", comnCd: "OSC0130" }],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Registering HS Code Form !== HS 신청 Form==!
        srchHsCtgr: useForm({
            defaultSchema: SF_SRCH_HS_CTGR,
            defaultValues: {
                orgCd: auth.get("orgCd"),
                orgNm: auth.get("orgNm"),
            },
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        hsCtgrList: useGrid({
            defaultSchema: SG_HS_CTGR_LIST,
            page: 0,
            size: 10,
        }),
    };
    const render = {
        hsCtgrList: {
            head: {},
            cell: {
                hsCd: (props: any) => {
                    const { binding, rowValues, value } = props;
                    return (
                        <Layout direction="col" gap={1}>
                            <Link to={`${URLS.osci0204007s}/${rowValues.hsCtgrId}`}>
                                [{rowValues.hsCd}]{rowValues.hsDesc}
                            </Link>
                        </Layout>
                    );
                },
            },
            edit: {},
            row: (row: any, context: any) => {
                // row : 해당 row 의 데이터(rowValues)
                // return 값이 true 이면 row 보임
                // return 값이 false 이면 row 숨김
                // context 의 속성을 변경하여 row 의 바탕색 변경 가능
                if (row.prcsRoleTpCd === "SU" || row.prcsRoleTpCd === "AP") {
                    //context.backgroundColor = "blue"; // 3가지 색상 옵션 red , yellow , blue
                }
                return true;
            },
            checkbox: (row: any) => {
                // row : 해당 row 의 데이터(rowValues)
                return true; // !(row.deletableYn === "N");
            },
        },
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        getHsCtgrList: useFetch({
            api: async (page = grid.hsCtgrList.page) => {
                return APIS.getHsCtgrList(form.srchHsCtgr.getValues(), page, grid.hsCtgrList.size);
            },
            enabled: comnUtils.isEmpty(form.srchHsCtgr.errors),
            key: [grid.hsCtgrList.page, grid.hsCtgrList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.srchHsCtgr.getValues(),
                    page: grid.hsCtgrList.page,
                    size: grid.hsCtgrList.size,
                });
            },
            onError: () => {},
            showToast: false,
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // Delete Item list deletion event !== 품목 목록 삭제 이벤트 ==!
        click_Btn_DeleteGridAppHsCodeList: () => {
            const seltList: any[] = grid.hsCtgrList.getChecked() || [];
            if (comnUtils.isEmpty(seltList)) {
                modal.openModal({ content: "msg.osc.00009" });
                return;
            }

            grid.hsCtgrList.deleteRow("checkbox");

            // modal.openModal({
            //     content: "msg.osc.00095",
            //     onConfirm: () => {
            //         grid.appHsCodeList.deleteRow("checkbox");
            //     },
            // });
        },

        setInit: async () => {
            fetch.getHsCtgrList.fetch();
        },
    };

    // useEffect
    useEffect(() => {
        // 이전 검색 조건 세팅
        lpcoUtils.setSrchFormFromStore(form.srchHsCtgr, pgeStore);

        handler.setInit();
    }, []);

    return (
        <Page>
            {/* <form> */}
            <Group>
                <Group.Body>
                    <Layout>
                        <Layout.Left>
                            <Group.Title title={t("T_ITM_CTGR")} titleSize={1}></Group.Title>
                        </Layout.Left>
                    </Layout>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.srchHsCtgr.schema.srchItmCtgrTpCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.srchHsCtgr.schema.srchHsCd} />
                            <Group.Control {...form.srchHsCtgr.schema.srchRmrk} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control
                                {...form.srchHsCtgr.schema.srchAppdDt}
                                edit={true}
                                rangeButton={1}
                                controlSize={10}
                            />
                        </Group.Row>
                    </Group.Section>

                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="reset"
                                onClick={() => {
                                    form.srchHsCtgr.reset();
                                    fetch.getHsCtgrList.fetch();
                                }}
                            />
                        </Layout.Left>
                        <Layout.Right>
                            <Button
                                role="search"
                                onClick={() => {
                                    fetch.getHsCtgrList.fetch();
                                }}
                            />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>

            <Group>
                <Group.Body>
                    <Layout>
                        <Layout.Left>
                            <Group.Title title={t("T_HS_CD_LST")} titleSize={1}></Group.Title>
                        </Layout.Left>
                    </Layout>
                    <Layout>
                        <Layout.Left>
                            <Button
                                role="excelDownServer"
                                onClick={async () => {
                                    // excel download
                                    lpcoUtils.saveExcelDownload(
                                        process.env.REACT_APP_API_OSCI + "/api/v1/osci/lpco/hscd/ctgr/excel-down",
                                        form.srchHsCtgr.getValues(),
                                    );
                                }}
                            />
                        </Layout.Left>
                        <Layout.Right></Layout.Right>
                    </Layout>

                    <Group.Section>
                        <Grid
                            {...grid.hsCtgrList.grid}
                            data={fetch.getHsCtgrList.data?.list}
                            render={render.hsCtgrList}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
